import styles from './styles.mod.scss';
import classnames from 'classnames';
import { borderRadius, borderRadius0 } from 'scy/border.mod.scss';
import { inline } from 'scy/display.mod.scss';

import React from 'react';

export default function Button({
  variant,
  rect,
  noBorder,
  noUnderline,
  displayClass,
  inverted,
  className,
  Icon,
  children,
  ...rest
}) {
  const classes = buttonClasses({
    variant,
    rect,
    noBorder,
    noUnderline,
    displayClass,
    inverted,
    className
  });

  return (
    <button className={classes} {...rest}>
      {!!Icon && (
        <span className={styles.icon}>
          <Icon />
        </span>
      )}
      {children}
    </button>
  );
}

export function buttonClasses({
  variant,
  rect,
  noBorder,
  noUnderline,
  displayClass,
  inverted,
  className
} = {}) {
  if (variant === 'text') {
    return classnames(styles.text, displayClass || inline, className, {
      [styles.noUnderline]: noUnderline
    });
  }

  const colorClass = styles[`${variant}${inverted ? 'Inverted' : ''}`];

  return classnames(
    styles.button,
    colorClass,
    {
      [styles.transparentBorder]: noBorder,
      [borderRadius]: !rect,
      [borderRadius0]: rect
    },
    className
  );
}
